'use client';

import { useAuth } from './AuthProvider';
import { UserMenu } from './UserMenu';
import { UsageIndicator } from './UsageIndicator';
import { topNavLinkClassName } from '../../lib/navigation-styles';

export function NavAuth() {
  const { user, loading, openSignIn } = useAuth();

  // Don't render anything while loading to prevent flash
  if (loading) {
    return (
      <div className="w-8 h-8 rounded-full bg-muted-bg animate-pulse" />
    );
  }

  if (user) {
    return (
      <div className="flex items-center gap-2">
        <UsageIndicator variant="nav" />
        <UserMenu user={user} />
      </div>
    );
  }

  return (
    <button type="button" onClick={() => openSignIn('/upload')} className={topNavLinkClassName}>
      Sign in
    </button>
  );
}
